/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { PositionType } from 'chart.js';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-title-position',
  templateUrl: './theme-option-title-position.component.html',
  styleUrls: ['./theme-option-title-position.component.css']
})
export class ThemeOptionTitlePositionComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  positions = ['top', 'left', 'right', 'bottom'] as PositionType[];
  optionType: ThemeOptionType = 'title_position';
  showDetails: boolean;

  constructor() {}

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  receiveValue(value: PositionType, type?: ChartType) {
    this.themeOptions.setOption(this.optionType, value, type ? [type] : undefined);
  }

}
